export const getPasskeyCredentials = state => state.passkeys.credentials;
export const getShowPasskeyNudge = state => state.passkeys.showPasskeyNudge;
export const getPasskeyRedirectUrl = state => state.passkeys.redirectUrl;